'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  publishing: null,
  queue: (0, _immutable.List)()
}, 'OutgoingMessages');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/OutgoingMessages.js
// module id = 529
// module chunks = 0